import { render, staticRenderFns } from "./VueMarkdownWithAnchors.vue?vue&type=template&id=e97f78e4&lang=pug&"
import script from "./VueMarkdownWithAnchors.vue?vue&type=script&lang=ts&"
export * from "./VueMarkdownWithAnchors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports